const channelCodeName='channelCode';//渠道码用到的字段名（埋点统计）
export {
    channelCodeName,
}